async function sha256(text) {
  try {
    const data = new TextEncoder().encode(text);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(hashBuffer)).map((b) => b.toString(16).padStart(2, '0')).join('');
  } catch (_) {
    let hash = 0;
    const value = String(text || '');
    for (let i = 0; i < value.length; i += 1) hash = (hash * 31 + value.charCodeAt(i)) | 0;
    return `fallback-${Math.abs(hash)}`;
  }
}

export async function boardSessionStorageKey(token) {
  return `mini_tasks_board_session:${await sha256(String(token || ''))}`;
}

export async function readStoredBoardSession(token) {
  try {
    const key = await boardSessionStorageKey(token);
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.board_session_id) return null;
    return parsed;
  } catch (_) {
    return null;
  }
}

export async function writeStoredBoardSession(token, boardSession) {
  try {
    const key = await boardSessionStorageKey(token);
    window.localStorage.setItem(key, JSON.stringify({
      board_session_id: boardSession?.id,
      expires_at: boardSession?.expires_at,
    }));
  } catch (_) {
    // localStorage can be unavailable on locked-down browsers; backend remains authority.
  }
}
